<template>
  <!-- <v-row> -->
    <!-- <v-avatar color="primary" size="56" @click.stop="drawer = !drawer">TW</v-avatar> -->
    <v-navigation-drawer 
      v-model="drawer"
      :dark="true"
      mobile-break-point="960"
      app
      color="#444"
      mini-variant
      mini-variant-width="90">
      <v-list flat class="mt-4">
        <v-list-item-group v-model="selected_item">
          <v-list-item v-for="(item, i) in menu_items" :key="i" active-class="border" :ripple="false">
            <v-list-item-content>
              <v-icon v-text="item.icon"></v-icon>
              <v-list-item-subtitle align="center" v-text="item.text" class="mt-3 caption"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  <!-- </v-row> -->
</template>

<script>
import { mapState, } from 'vuex'

export default {

  data: () => ({
    selected_item: 0,
    // drawer: null,
    menu_items: [
      {icon: 'fas fa-home', text: 'Home'},
      {icon: 'fas fa-shopping-cart', text: 'New Cart'},
      {icon: 'fas fa-dollar', text: 'Register'},
      {icon: 'fas fa-cog', text: 'Settings'}
    ]
  }),

  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (val) {
        this.$store.commit('SET_DRAWER', val)
      },
    },
  }

}
  
</script>

<style>
</style>